import {
    GET_DISPOSITION_FEE_SCHEDULE,
    SET_DISPOSITION_COMMISSION,
    SET_DISPOSITION_PURCHASERS,
    UPDATE_DISPOSITION_COMMISSION
} from '../../types';

const initialState = {
    FeeSchedule: {
        schedule_type: null,
        set_up_fee: 0,
        monthly_admin_management_fee: 0,
        disposition_fee: 0,
        disposition_percentage: 0,
        contingency: 0,
        title_clearing_fee: 0,
        appraisal_fee: 0,
        contract_commission_rate: 0,
        participation: null,
        inspection_fee: 0
    },
    CommissionData: {
        bonus: '0.00',
        commission_paid_to_broker_dollar: '0.00',
        commission_paid_to_broker_percent: '0.00',
        contract_commission_rate_dollar: '0.00',
        contract_commission_rate_percent: '0.00',
        disposition_brokerage_fee_dollar: '0.00',
        disposition_brokerage_fee_percent: '0.00',
        gross_commission_earned: '0.00',
        gross_sales_amount: '0.00',
        net_commission_earned: '0.00'
    },
    PurchasersData: []
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_DISPOSITION_FEE_SCHEDULE:
            return {
                ...state,
                FeeSchedule: { ...payload }
            };
        case SET_DISPOSITION_COMMISSION:
            return {
                ...state,
                CommissionData: {
                    ...state.CommissionData,
                    ...payload
                }
            };
        case UPDATE_DISPOSITION_COMMISSION:
            return {
                ...state,
                CommissionData: {
                    ...state.CommissionData,
                    ...payload
                }
            };
        case SET_DISPOSITION_PURCHASERS:
            return {
                ...state,
                PurchasersData: [...payload]
            };
        default:
            return state;
    }
}